import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk for fetching service data
export const fetchServiceData = createAsyncThunk(
  'products/fetchServiceData',
  async (_, { rejectWithValue }) => {
    try {
      // Check cache first
      const cached = sessionStorage.getItem('serviceData');
      if (cached) {
        return JSON.parse(cached);
      }

      const base = process.env.PUBLIC_URL || '';
      const response = await fetch(`${base}/items/service.json`);
      if (!response.ok) {
        throw new Error('Failed to fetch service data');
      }
      const data = await response.json();
      // Cache for session
      sessionStorage.setItem('serviceData', JSON.stringify(data));
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  serviceData: null,
  activeService: 'website-development',
  loading: false,
  error: null,
  visibleSections: [],
  lastScrollPosition: 0,
};

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setActiveService: (state, action) => {
      state.activeService = action.payload;
    },
    addVisibleSection: (state, action) => {
      if (!state.visibleSections.includes(action.payload)) {
        state.visibleSections.push(action.payload);
      }
    },
    setScrollPosition: (state, action) => {
      state.lastScrollPosition = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchServiceData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchServiceData.fulfilled, (state, action) => {
        state.loading = false;
        state.serviceData = action.payload;
        state.error = null;
      })
      .addCase(fetchServiceData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setActiveService,
  addVisibleSection,
  setScrollPosition,
  clearError,
} = productsSlice.actions;

export default productsSlice.reducer;

